import { api } from "./http";

export const categoryApi = {
  getAll: () => api.get("/categories"),
  getById: (id) => api.get(`/categories/${id}`),
  create: (data) => api.post("/api/Category/category", data),
  update: (id, data) => api.put(`/api/Category/category`, data),
  remove: (id) => api.delete(`api/Category/category?id=${id}`),
  getTable: (param) => api.post("/api/Category/table",param)
};
